import { FC, PropsWithChildren } from "react";

const EventProvider: FC<PropsWithChildren> = ({children}) => {
  return <>
    {children}
  </>
}
export default EventProvider;